import React, { act, useEffect, useRef, useState } from "react";
import backIcon from "../../../assets/Review/back-icon.svg";
import "./style.scss";
import Button from "../../../common/Button";
import small from "../../../assets/Review/small.svg";
import bigImage from "../../../assets/Review/bigImage.svg";
import EditCircleIcon from "../../../assets/Review/editCircleIcon.svg";
import EditRectangleIcon from "../../../assets/Review/editRectangleIcon.svg";
import EditPencilIcon from "../../../assets/Review/pencilIcon.svg";
import UndoIcon from "../../../assets/Review/undoIcon.svg";
import deleteIcon from "../../../assets/Review/delete.svg";
import {
  useAcceptFileOnReview,
  useDeleteMarkingsOnFile,
  useGetSkuForReview,
  useRejectSkuOnReview,
  useSaveMarkingsOnFile,
} from "../../../hooks/useReview";
import { useNavigate, useParams } from "react-router-dom";
import { message, Modal, Select, Spin, Tooltip } from "antd";
import pendingIcon from "../../../assets/Review/pendingIcon.svg";
import rejectedIcon from "../../../assets/Review/rejected.svg";
import successIcon from "../../../assets/Review/success.svg";
const ReviewDetail = () => {
  const [formInputs, setFormInputs] = useState({
    mainReason: null,
    specificReason: null,
    addComment: "",
  });
  const params = useParams();
  const navigate = useNavigate();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [drawing, setDrawing] = useState(false);
  const [tool, setTool] = useState("");
  const [shapes, setShapes] = useState([]);
  const [currentShape, setCurrentShape] = useState(null);
  const canvasRef = useRef(null);
  const canvasRef2 = useRef(null);
  const [pencilPath, setPencilPath] = useState([]);
  const [activeFileId, setActiveFileId] = useState(params?.activeFileId);
  const [skuData, setSkuData] = useState();
  const [activeMarketPlaceId, setActiveMarketPlaceId] = useState();
  const [images, setImages] = useState([]);
  const [reason, setReasons] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [isWebhookCalled, setIsWebhookCalled] = useState(false);
  const [imageLoad, setImageLoad] = useState(false);
  const { Option } = Select;
  const statusIcons = {
    600: { src: pendingIcon, alt: "pending" },
    700: { src: pendingIcon, alt: "pending" },
    606: { src: successIcon, alt: "accepted" },
    706: { src: successIcon, alt: "accepted" },
    608: { src: rejectedIcon, alt: "rejected" },
    708: { src: rejectedIcon, alt: "rejected" },
  };
  const handleChange = (e) => {
    const name = e?.target?.name;
    const value = e?.target?.value;
    setFormInputs((prev) => ({ ...prev, [name]: value }));
  };
  const onSuccessAcceptFile = (res) => {
    if (res.status === 200) {
      message.success("File Accepted");
      getSkuDetails();
    }
  };
  const onErrorAcceptFile = (err) => {
    console.log(err);
  };

  const { mutate: acceptFileOnReview } = useAcceptFileOnReview(
    onSuccessAcceptFile,
    onErrorAcceptFile
  );
  const onSuccessRejectFile = (res) => {
    if (res.status === 200) {
      message.error("File Rejected");
      getSkuDetails();
    }
  };
  const onErrorRejectFile = (err) => {
    console.log(err);
    let errorMessage = "An error occurred";
    try {
      const errorData = JSON.parse(err?.response?.data);
      errorMessage = errorData?.message || errorMessage;
    } catch (e) {
      console.error("Failed to parse error response:", e);
    }
    message.error(errorMessage);
  };
  const { mutate: rejectFileOnReview } = useRejectSkuOnReview(
    onSuccessRejectFile,
    onErrorRejectFile
  );
  const onSuccessSaveMarking = (res) => {
    if (res.status === 200) {
      message.success("Markings Saved");
      getSkuDetails();
      setPencilPath([]);
      setShapes([]);
      setTool("");
      setFormInputs({
        mainReason: null,
        specificReason: null,
        addComment: "",
      });
      // setActiveFileId((prevActiveFileId) => {
      //   const currentIndex = images.findIndex(
      //     (file) => file?._id === prevActiveFileId
      //   );
      //   if (currentIndex < images.length - 1) {
      //     return images[currentIndex + 1]?._id;
      //   }
      //   return prevActiveFileId;
      // });
    }
  };
  const onErrorSaveMarking = (err) => {
    console.log(err);
  };

  const { mutate: saveMarkingsOnFile } = useSaveMarkingsOnFile(
    onSuccessSaveMarking,
    onErrorSaveMarking
  );

  const onSuccess = (res) => {
    if (res.status === 200) {
      setSkuData(res?.data?.data?.sku);
      setReasons(res?.data?.data?.rejectReasons);
      setIsWebhookCalled(res?.data?.data?.sku?.isWebhookCalled);
    }
  };
  const onError = (err) => {
    console.log(err);
  };
  const { data, refetch: getSkuDetails } = useGetSkuForReview(
    "getSkuForReview",
    params?.batchId,
    params?.skuId,
    onSuccess,
    onError
  );

  const onSuccessDeleteMarkingsOnFile = (res) => {
    if (res.status === 200) {
      message.success("Markings Deleted");
      getSkuDetails();
    }
  };
  const onErrorDeleteMarkingsOnFile = (err) => {
    console.log(err);
  };

  const { mutate: deleteMarkingsOnFile } = useDeleteMarkingsOnFile(
    onSuccessDeleteMarkingsOnFile,
    onErrorDeleteMarkingsOnFile
  );

  const handleDelete = (markingId, fileId) => {
    deleteMarkingsOnFile({
      processFileId: fileId,
      markingId: markingId,
    });
  };

  const generateRandomId = () => {
    return Math.random().toString(36).substring(7);
  };
  const handleAccept = () => {
    acceptFileOnReview({ processFileId: activeFileId });
  };
  const handleReject = () => {
    rejectFileOnReview({ processFileId: activeFileId });
  };
  const handleToolChange = (newTool) => {
    setTool(newTool);
    setShapes([]);
    setCurrentShape(null);
    setPencilPath([]);
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    setIsSubmitted(true);
    const payload = {
      processFileId: activeFileId,
      markings: {
        markWidth: shapes[0]?.width,
        markHeight: shapes[0]?.height,
        markPositionOnImgX: shapes[0]?.x,
        markPositionOnImgY: shapes[0]?.y,
        error: `${formInputs?.mainReason || ""},${
          formInputs?.specificReason || ""
        },${formInputs?.addComment || ""}`,
        rejectionReasonMain: formInputs?.mainReason,
        specificReason: formInputs?.specificReason,
        id: `mark${generateRandomId()}`,
        color: "#FF0000",
        markType: shapes[0]?.type,
      },
    };
    const payload2 = {
      processFileId: activeFileId,
      markings: {
        error: `${formInputs?.mainReason || ""},${
          formInputs?.specificReason || ""
        },${formInputs?.addComment || ""}`,
        rejectionReasonMain: formInputs?.mainReason,
        specificReason: formInputs?.specificReason,
        id: `mark${generateRandomId()}`,
        color: "#FF0000",
        markType: "freehand",
        freeHandArray: shapes[0]?.path?.map((point, index) => ({
          positionX: point?.x,
          positionY: point?.y,
        })),
      },
    };
    saveMarkingsOnFile(shapes[0]?.type === "pencil" ? payload2 : payload);
  };
  const wrapText = (ctx, text, x, y, maxWidth, lineHeight) => {
    const words = text.split(" ");
    let line = "";
    for (let n = 0; n < words.length; n++) {
      const testLine = line + words[n] + " ";
      const metrics = ctx.measureText(testLine);
      const testWidth = metrics.width;
      if (testWidth > maxWidth && n > 0) {
        ctx.fillText(line, x, y);
        line = words[n] + " ";
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
    ctx.fillText(line, x, y);
  };
  const startDrawing = (e) => {
    setDrawing(true);
    const { offsetX, offsetY } = e.nativeEvent;
    setShapes([]);
    if (tool === "pencil") {
      setPencilPath([{ x: offsetX, y: offsetY }]);
    } else if (tool === "ellipse" || tool === "rectangle") {
      setCurrentShape({
        type: tool,
        x: offsetX,
        y: offsetY,
        width: 0,
        height: 0,
      });
    }
  };

  const draw = (e) => {
    if (!drawing) return;
    const { offsetX, offsetY } = e.nativeEvent;
    if (tool === "pencil") {
      setPencilPath((prevPath) => [...prevPath, { x: offsetX, y: offsetY }]);
    } else if (tool === "ellipse" || tool === "rectangle") {
      const width = offsetX - currentShape.x;
      const height = offsetY - currentShape.y;
      setCurrentShape({ ...currentShape, width, height });
    }
  };

  const stopDrawing = () => {
    if (!drawing) return;
    if (tool === "ellipse" || tool === "rectangle") {
      setShapes([currentShape]);
      setCurrentShape(null);
    } else if (tool === "pencil") {
      setShapes([{ type: "pencil", path: pencilPath }]);
      setPencilPath([]);
    }

    setDrawing(false);
  };

  const drawShape = (ctx, shape) => {
    if (ctx) {
      ctx.strokeStyle = "#da0707";
      ctx.lineWidth = 2;

      if (shape.type === "ellipse") {
        const centerX = shape.x + shape.width / 2;
        const centerY = shape.y + shape.height / 2;
        ctx.beginPath();
        ctx.ellipse(
          centerX,
          centerY,
          Math.abs(shape.width) / 2,
          Math.abs(shape.height) / 2,
          0,
          0,
          2 * Math.PI
        );
        ctx.stroke();
      } else if (shape.type === "rectangle") {
        ctx.strokeRect(shape.x, shape.y, shape.width, shape.height);
      } else if (shape.type === "pencil") {
        ctx.beginPath();
        shape.path.forEach((point, index) => {
          if (index === 0) {
            ctx.moveTo(point.x, point.y);
          } else {
            ctx.lineTo(point.x, point.y);
          }
        });
        ctx.stroke();
      }
    }
  };

  const redrawCanvas = () => {
    const canvas = canvasRef.current;
    const canvas2 = canvasRef2.current;
    if (!canvas) return;
    const ctx = canvas?.getContext("2d");
    ctx?.clearRect(0, 0, canvas.width, canvas.height);

    const ctx2 = canvas2?.getContext("2d");
    ctx2?.clearRect(0, 0, canvas2.width, canvas2.height);
    // Draw existing markings
    const currentImage = images?.filter(
      (file) => file?._id === activeFileId
    )[0];
    if (currentImage?.deliverable?.markings) {
      currentImage.deliverable.markings.forEach((marking) => {
        drawShape(ctx, {
          type: marking.markType === "freehand" ? "pencil" : marking.markType,
          x: marking?.markPositionOnImgX,
          y: marking?.markPositionOnImgY,
          width: marking?.markWidth,
          height: marking?.markHeight,
          path:
            marking.markType === "freehand"
              ? marking?.freeHandArray?.map((point) => ({
                  x: point.positionX,
                  y: point.positionY,
                }))
              : marking?.freeHandArray,
        });
        const positionX =
          marking.markType === "freehand"
            ? marking?.freeHandArray[0]?.positionX
            : marking?.markPositionOnImgX;
        const positionY =
          marking.markType === "freehand"
            ? marking?.freeHandArray[0]?.positionY
            : marking?.markPositionOnImgY;

        // Draw error text if it exists
        if (marking?.error) {
          ctx.font = "10px Arial";
          ctx.fillStyle = "red";
          wrapText(ctx, marking.error, positionX, positionY - 5, 100, 12);
        }
      });
    }

    //draw markings for the last version
    if (currentImage?.deliverable?.lastVersionRef?.deliverable?.markings) {
      currentImage.deliverable.lastVersionRef?.deliverable?.markings.forEach(
        (marking) => {
          drawShape(ctx2, {
            type: marking.markType === "freehand" ? "pencil" : marking.markType,
            x: marking?.markPositionOnImgX,
            y: marking?.markPositionOnImgY,
            width: marking?.markWidth,
            height: marking?.markHeight,
            path:
              marking.markType === "freehand"
                ? marking?.freeHandArray?.map((point) => ({
                    x: point.positionX,
                    y: point.positionY,
                  }))
                : marking?.freeHandArray,
          });
          const positionX =
            marking.markType === "freehand"
              ? marking?.freeHandArray[0]?.positionX
              : marking?.markPositionOnImgX;
          const positionY =
            marking.markType === "freehand"
              ? marking?.freeHandArray[0]?.positionY
              : marking?.markPositionOnImgY;

          // Draw error text if it exists
          if (marking?.error) {
            ctx2.font = "10px Arial";
            ctx2.fillStyle = "red";
            wrapText(ctx2, marking.error, positionX, positionY - 5, 100, 12);
          }
        }
      );
    }
    shapes.forEach((shape) => drawShape(ctx, shape));
    if (currentShape) {
      drawShape(ctx, currentShape);
    }

    if (tool === "pencil" && pencilPath.length > 0) {
      drawShape(ctx, { type: "pencil", path: pencilPath });
    }
  };

  const undoLastShape = () => {
    setShapes((prevShapes) => prevShapes.slice(0, -1));
  };

  const resizeCanvas = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const parentElement = canvas.parentElement;
    const rect = parentElement.getBoundingClientRect();

    const scaleX = rect.width / canvas.width;
    const scaleY = rect.height / canvas.height;

    canvas.width = rect.width;
    canvas.height = rect.height;

    setShapes((prevShapes) =>
      prevShapes.map((shape) => {
        if (shape.type === "pencil") {
          return {
            ...shape,
            path: shape.path.map((point) => ({
              x: point.x * scaleX,
              y: point.y * scaleY,
            })),
          };
        }
        return {
          ...shape,
          x: shape.x * scaleX,
          y: shape.y * scaleY,
          width: shape.width * scaleX,
          height: shape.height * scaleY,
        };
      })
    );
  };

  useEffect(() => {
    resizeCanvas();

    window.addEventListener("resize", resizeCanvas);
    return () => window.removeEventListener("resize", resizeCanvas);
  }, []);

  useEffect(() => {
    const handleAnimationFrame = () => {
      redrawCanvas();
      requestAnimationFrame(handleAnimationFrame);
    };
    requestAnimationFrame(handleAnimationFrame);
    return () => cancelAnimationFrame(handleAnimationFrame);
  }, [shapes, pencilPath, currentShape, tool, images, activeFileId]);
  const handleAll = () => {
    const allImages = skuData?.processFiles?.reduce((acc, item) => {
      return acc.concat(item.files);
    }, []);
    setImages(allImages);
    setActiveMarketPlaceId(null);
  };
  useEffect(() => {
    if (skuData) {
      handleAll();
    }
  }, [skuData]);
  const handleClose = () => {
    const hasUnmarkedFiles = images.some(
      (x) =>
        x?.deliverable?.markings?.length > 0 &&
        x?.status !== 608 &&
        x?.status !== 708
    );
    if (hasUnmarkedFiles) {
      setConfirmModal(true);
    } else {
      navigate(`/review-sku-list/${params?.batchId}`);
    }
  };
  const handleMultupleReject = () => {
    const unmarkedFiles = images.filter(
      (x) =>
        x?.deliverable?.markings?.length > 0 &&
        x?.status !== 608 &&
        x?.status !== 708
    );
    unmarkedFiles.forEach((file) => {
      rejectFileOnReview({ processFileId: file?._id });
    });
    setConfirmModal(false);
  };
  const getConfirmCloseModal = () => {
    return (
      <Modal
        title="Confirmation"
        open={confirmModal}
        footer={null}
        width="70%"
        // height="80dvh"
        centered
        className="confirmation_modal_wrapper"
        onCancel={() => setConfirmModal(false)}
      >
        <div className="message_wrapper">
          <div className="message">
            You have marked some files, but have not rejected them yet.
          </div>
          <div className="action_wrapper">
            <button className="cancel" onClick={() => setConfirmModal(false)}>
              Cancel
            </button>
            <Button
              text="Reject Files"
              width="120px"
              height="40px"
              showIcon={false}
              handleClick={() => handleMultupleReject()}
            />
          </div>
        </div>
      </Modal>
    );
  };
  const handleImageLoading = () => {
    console.log("loaded");
    setImageLoad(false);
  };
  return (
    <div className="review_detail">
      <div className="review_detail_wrapper">
        <div className="detail_header">
          <div className="detail_left">
            <div className="back_action">
              <img
                src={backIcon}
                alt=""
                onClick={() => navigate(`/review-sku-list/${params?.batchId}`)}
              />
            </div>
            <div className="batch_name">
              <h2>{skuData?.skuName}</h2>
              <div className="tabs_section_details">
                <div
                  className={`tab ${
                    activeMarketPlaceId === null ? "active" : ""
                  }`}
                  onClick={() => handleAll()}
                >
                  All Images
                </div>
                {skuData?.processFiles?.map((item) => {
                  return (
                    <div
                      key={item?.marketplaceId}
                      className={`tab ${
                        activeMarketPlaceId === item?.marketplaceId
                          ? "active"
                          : ""
                      }`}
                      onClick={() => {
                        setActiveMarketPlaceId(item?.marketplaceId);
                        setImages(item?.files);
                      }}
                    >
                      {item?.marketplaceName}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="detail_right">
            <div className="actions">
              <Button
                text="Accept"
                width="89px"
                height="42px"
                showIcon={false}
                handleClick={handleAccept}
                isDisabled={
                  images?.filter((file) => file?._id === activeFileId)[0]
                    ?.isWebhookCalled
                }
              />
              {images.filter((x) => x?._id === activeFileId)[0]?.deliverable
                ?.markings?.length === 0 ? (
                <Tooltip
                  title="At least 1 marking required to enable"
                  placement="rightTop"
                >
                  <button
                    className="reject disabled"
                    onClick={handleReject}
                    disabled
                  >
                    Reject
                  </button>
                </Tooltip>
              ) : (
                <button
                  className={`reject ${
                    images?.filter((file) => file?._id === activeFileId)[0]
                      ?.isWebhookCalled && "disabled"
                  } `}
                  onClick={handleReject}
                  disabled={
                    images?.filter((file) => file?._id === activeFileId)[0]
                      ?.isWebhookCalled
                  }
                >
                  Reject
                </button>
              )}
              <button className="accept" onClick={handleClose}>
                Close
              </button>
            </div>
          </div>
        </div>
        <div className="detail_content">
          <div className="col_1">
            <div className="image_preview">
              {images?.length > 0 &&
                images?.map((file) => {
                  return (
                    <div
                      className={`images ${
                        activeFileId === file?._id ? "active" : ""
                      }`}
                      onClick={() => {
                        setActiveFileId(file?._id);
                        // setImageLoad(true);
                      }}
                    >
                      <img
                        src={file?.deliverable.displayFile?.thumbPath?.url}
                        alt={file?.mainFile?.image?.name}
                      />
                      <div className="status_icon_wrapper">
                        {statusIcons[file?.status] && (
                          <img
                            src={statusIcons[file.status].src || ""}
                            alt={statusIcons[file.status].alt}
                          />
                        )}
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="big-image">
              <img
                src={
                  images?.filter((file) => file?._id === activeFileId)[0]
                    ?.deliverable?.lastVersionRef
                    ? images?.filter((file) => file?._id === activeFileId)[0]
                        ?.deliverable?.lastVersionRef?.deliverable?.displayFile
                        ?.imagePath?.url
                    : images?.filter((file) => file?._id === activeFileId)[0]
                        ?.mainFile?.image?.imagePath?.url
                }
                alt=""
              />
              {images?.filter((file) => file?._id === activeFileId)[0]
                ?.deliverable?.lastVersionRef && (
                <canvas
                  ref={canvasRef2}
                  width={360}
                  height={500}
                  style={{
                    // border: "1px solid black",
                    top: 0,
                    left: 0,
                    position: "absolute",
                    zIndex: 20,
                    backgroundColor: "transparent",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                ></canvas>
              )}
            </div>
          </div>
          <div className="col_2">
            <div className="image_container">
              {console.log(imageLoad)}
              {imageLoad ? (
                <Spin size={16} />
              ) : (
                <img
                  src={
                    images?.filter((file) => file?._id === activeFileId)[0]
                      ?.deliverable?.displayFile?.imagePath?.url
                  }
                  alt=""
                  // onLoad={handleImageLoading}
                />
              )}
              <canvas
                ref={canvasRef}
                onMouseDown={startDrawing}
                onMouseMove={draw}
                onMouseUp={stopDrawing}
                onMouseLeave={stopDrawing}
                width={360}
                height={500}
                style={{
                  // border: "1px solid black",
                  top: 0,
                  left: 0,
                  position: "absolute",
                  zIndex: 2,
                  backgroundColor: "transparent",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              ></canvas>
            </div>
          </div>
          <div className="col_3">
            <div className="drawing_container">
              <h2>Mark Changes</h2>
              <div className="action_wrapper">
                <button
                  className={`editBtn ${
                    tool === "rectangle" ? "activeBtn" : ""
                  }`}
                  onClick={() => handleToolChange("rectangle")}
                >
                  <img src={EditRectangleIcon} alt="edit_rectangle" />
                </button>
                <button
                  className={`editBtn ${tool === "ellipse" ? "activeBtn" : ""}`}
                  onClick={() => handleToolChange("ellipse")}
                >
                  <img src={EditCircleIcon} alt="edit_rectangle" />
                </button>
                <button
                  className={`editBtn ${tool === "pencil" ? "activeBtn" : ""}`}
                  onClick={() => handleToolChange("pencil")}
                >
                  <img src={EditPencilIcon} alt="edit_rectangle" />
                </button>
                <button className="editBtn" onClick={undoLastShape}>
                  <img src={UndoIcon} alt="undoIcon" />
                </button>
              </div>
            </div>
            <div className="comment_container">
              <h2>Add Comment</h2>
              <form onSubmit={handleSubmit}>
                <div className="field">
                  <label>Main Reason</label>
                  <Select
                    name="mainReason"
                    value={formInputs?.mainReason}
                    onChange={(value) =>
                      handleChange({ target: { name: "mainReason", value } })
                    }
                    placeholder="Select Main Reason"
                  >
                    {reason?.map((item) => (
                      <Option key={item?.reason?._id} value={item?.reason}>
                        {item?.reason}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="field">
                  <Select
                    name="specificReason"
                    value={formInputs?.specificReason}
                    placeholder="Select Specific Reason"
                    onChange={(value) =>
                      handleChange({
                        target: { name: "specificReason", value },
                      })
                    }
                  >
                    {reason
                      ?.filter((x) => x?.reason === formInputs?.mainReason)[0]
                      ?.subReasons?.map((item) => (
                        <Option key={item?._id} value={item}>
                          {item}
                        </Option>
                      ))}
                  </Select>
                  <textarea
                    placeholder="Add Comment"
                    name="addComment"
                    value={formInputs?.addComment}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
                <div className="action_wrapper">
                  <Button
                    width="70px"
                    height="42px"
                    showIcon={false}
                    text="Add"
                    isDisabled={
                      shapes.length === 0 ||
                      !(
                        formInputs?.mainReason ||
                        formInputs?.specificReason ||
                        formInputs?.addComment
                      )
                    }
                  />
                  {/* <button className="cancel" disabled>
                    Cancel
                  </button> */}
                </div>
              </form>
            </div>
            <div className="comment_list_main_container">
              {images
                .filter((x) => x?._id === activeFileId)[0]
                ?.deliverable?.markings?.map((marking, index) => {
                  return (
                    <div className="comment_wrapper" key={marking?._id}>
                      <img
                        src={deleteIcon}
                        alt="delete_icon"
                        className="deleteIcon"
                        onClick={() => handleDelete(marking?._id, activeFileId)}
                      />
                      <div className="comment">
                        <h4>Main Reason:</h4>
                        <p>{marking?.rejectionReasonMain}</p>
                      </div>
                      <div className="comment">
                        <h4>Specific Reason:</h4>
                        <p>{marking?.specificReason}</p>
                      </div>
                      <div className="comment">
                        <h4>Add Comment:</h4>
                        <p>{marking?.error.split(",").slice(-1)[0] || ""}</p>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      {confirmModal && getConfirmCloseModal()}
    </div>
  );
};

export default ReviewDetail;
